"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITES_HEART = exports.BUTTONS = void 0;
const BUTTONS = exports.BUTTONS = 'buttons';
const FAVORITES_HEART = exports.FAVORITES_HEART = 'favorites-heart';
